import { AxiosInstance } from 'axios'

import { userApiDefaultApiFactory } from '@src/api/default-api-factories'
import {
  DefaultApiIssueChallengeRequest,
  DefaultApiVerifyChallengeRequest,
  DefaultApiIntrospectChallengeSuccessTokenRequest,
  // Do Not Remove this line ===@import api type===
} from '@src/api/generated/user-api'

export const issueChallenge = async (
  instance: AxiosInstance,
  params: DefaultApiIssueChallengeRequest
) => {
  return await userApiDefaultApiFactory(instance).issueChallenge(params)
}

export const verifyChallenge = async (
  instance: AxiosInstance,
  params: DefaultApiVerifyChallengeRequest
) => {
  return await userApiDefaultApiFactory(instance).verifyChallenge(params)
}

export const introspectChallengeSuccessToken = async (
  instance: AxiosInstance,
  params: DefaultApiIntrospectChallengeSuccessTokenRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).introspectChallengeSuccessToken(params)
}

// Do Not Remove this line ===@import api client===
